import Cookies from 'js-cookie';

export const PXResources = (function () {
	'use strict';

	var $filters, $results, params, $modalFilter, $regionFilter, terms, $toggleTerms, $noResults;

	function init() {
		if ($('.pxblock--resources').length === 0) return;

		if (!$('body').hasClass('wp-admin')) {
			// MicroModal.show('solutions');
			// if (Cookies.get('solutions-filter')) {
			// 	setSolutionFilter(Cookies.get('solutions-filter'));
			// } else {
			// 	MicroModal.show('solutions');
			// }
		}

		$filters = $('.filters input[type="checkbox"], .filters input[type="radio"]');
		$results = $('.result');
		$modalFilter = $('.modal [data-filter]');
		$regionFilter = $('.filter--region input');
		$toggleTerms = $('.filter-label.toggle-terms');
		$noResults = $('.results__none');
		params = new URLSearchParams(window.location.search);
		displayTerms();
		filter_results();
		hideRegion();
		events();
	}

	function displayTerms() {
		// only display applicable terms

		terms = [];

		$results.each((idx, el) => {
			let elTaxes = el.getAttribute('data-taxes');

			if (elTaxes.includes(',')) {
				elTaxes = elTaxes.split(',');

				elTaxes.forEach((tax) => {
					if (!terms.includes(tax)) {
						terms.push(tax);
					}
				});
			} else {
				if (!terms.includes(elTaxes)) {
					terms.push(elTaxes);
				}
			}
		});

		if (!terms.some((term) => term.includes('region'))) {
			// If there is no region option, do this
			$('.filter--region').hide();
		}

		terms.forEach((term) => {
			let termInput = document.getElementById(term);
			if (termInput) {
				$(termInput).parent('.input-row').show();
				$(termInput).closest('.filter').show();
				$(termInput).siblings('label').css('display', 'inline-block');
			}
		});

		// On load, the region will have ALL selected
		$('.filter').each(function () {
			var $this = $(this);
			// console.log(window.location.href.indexOf("region-all"));
			if (window.location.href.indexOf('region') < 0 || window.location.href.indexOf('region-all') > 0) {
				$this.find('.region-all').attr('checked', 'checked');
			}
		});
	}

	function events() {
		$filters.on('change', filter_results);

		$('.resource-searchform').on('submit', (ev) => {
			ev.preventDefault();
			filter_results();
		});

		// Ability to check/uncheck the region radio buttons
		document.querySelectorAll('label[for^="region"]').forEach((regionLabel) => {
			const onAction = (ev) => {
				ev.preventDefault();

				let regionInput = regionLabel.parentNode.querySelector('input');

				// console.log(ev.currentTarget, regionInput.checked);
				// if(regionInput.checked) {
				// 	console.log('sane is unchecked', ev.path[2].firstChild.querySelector('input').checked);
				// 	// ev.path[2].firstChild.querySelector('input').checked = true;
				// 	regionInput.checked = !regionInput.checked;
				// }

				regionInput.checked = !regionInput.checked;
				if (!regionInput.checked) {
					// If clicked on checked, activate all
					// console.log('regionall on');
					$('#region-all').prop('checked', true);
				}
				$filters.trigger('change');
				// console.log(ev.currentTarget);
			}
			regionLabel.addEventListener('keypress', (ev) => {
				ev.key === 'Enter' && onAction(ev)
			})
			regionLabel.addEventListener('click', onAction);

		});

		$('#js-sorter').on('change', reverseItems);

		$('#clear-filters, [data-clear-filters]').on('click', clear_filters);

		$modalFilter.click(function (e) {
			e.preventDefault();
			let filterSlug = $(this).data('filter');
			setSolutionFilter(filterSlug);
			MicroModal.close();
		});

		// $regionFilter.click(function (e) {
		// 	if (this.className == 'head-and-neck' || this.className == 'upper-body' || this.className == 'lower-body') {
		// 		Cookies.set('solutions-filter', this.className, { expires: 7 });
		// 	}
		// });

		$toggleTerms.addClass('expanded');

		const $termRow = $('.input-rows-parent');

		$termRow.css('display', 'block');

		$toggleTerms.click(function () {
			const $this = $(this);
			if ($this.attr('aria-expanded') === 'true') {
				$this.removeClass('expanded').attr('aria-expanded', 'false');
			} else {
				$this.addClass('expanded').attr('aria-expanded', 'true');
			}
			
			$(this).parent().siblings('.input-rows-parent').stop().slideToggle();
		});

		document
			.getElementById('mobile-filters-trigger')
			.addEventListener('click', (ev) => document.body.classList.toggle('resource-filters-open'));

		document.querySelector('.filters-heading__close').addEventListener('click', (ev) => {
			ev.preventDefault();
			document.body.classList.toggle('resource-filters-open');
		});

		document.querySelectorAll('.filters__mobile-actions button').forEach((b) => {
			b.addEventListener('click', (ev) => {
				ev.preventDefault;
				document.body.classList.toggle('resource-filters-open');
			});
		});
	}

	function hideRegion(){
		if ($('.pxblock--resources').hasClass('hide--yes')) {
			if ($('.pxblock--resources .filter--region').length) {
				$('.pxblock--resources .filter--region').addClass('hide-region');
			}
		}
	}

	/**
	 * Lightweight reverse order for results.
	 */
	function reverseItems() {
		var list = $('#js-sorted-items');
		var listItems = list.children('#js-sorted-items > .result');
		list.append(listItems.get().reverse());
	}

	function setSolutionFilter(filterSlug) {
		if ($('input.' + filterSlug)) {
			$('input.' + filterSlug).trigger('click');
			// Cookies.set('solutions-filter', filterSlug, { expires: 7 });
		}
	}

	function get_pill_node(text, value) {
		let li = document.createElement('li');
		let span = document.createElement('span');
		let close = document.createElement('button');

		li.classList.add('pill');
		close.classList.add('pill__close');
		close.dataset.pillValue = value;
		span.innerText = text;

		close.addEventListener('click', (ev) => {
			let targetInput = document.getElementById(value);

			if (targetInput.name === 'region') {
				document.getElementById('region-all').checked = true;
			} else {
				targetInput.checked = false;
			}

			filter_results();
		});

		li.appendChild(span);
		li.appendChild(close);

		return li;
	}

	function update_mobile_filters() {
		let checkedFilters = document.querySelectorAll('.pxblock--resources__filters-form input:checked');
		let mobileFiltersPillsContainer = document.getElementById('mobile-filters-pills-container');

		while (mobileFiltersPillsContainer.firstChild) {
			mobileFiltersPillsContainer.removeChild(mobileFiltersPillsContainer.firstChild);
		}

		if (checkedFilters.length === 0) return;

		checkedFilters.forEach((f) => {
			let pill = get_pill_node(f.dataset.label, f.id);
			mobileFiltersPillsContainer.appendChild(pill);
		});
	}

	function filter_results(ev) {
		$results.hide();
		$('.amigo').removeClass('active');

		let activeSearchTerm = $('.resource-searchform:visible').serializeArray()[0].value.toLowerCase();

		let activeFilters = $('.pxblock--resources__filters-form')
			.serializeArray()
			// .filter((f) => f.value !== '' && f.value !== 'region-all')
			.map((f) => (f.name === 'region' ? f.value : f.name));

		let activeRegions = activeFilters.filter((f) => f.indexOf('region') > -1);
		let activeTopics = activeFilters.filter((f) => !f.includes('region'));

		console.log(activeSearchTerm, activeFilters, activeRegions);

		update_mobile_filters();

		// Visually show active regions
		activeRegions.forEach((r) => {
			switch (r) {
				case 'region--12':
					$('.amigo--head-neck').addClass('active');
					break;

				case 'region--15':
					$('.amigo--lower').addClass('active');
					break;

				case 'region--20':
					$('.amigo--upper').addClass('active');
					break;

				default:
					$('.amigo--gray').addClass('active');
					break;
			}
		});

		// Update URL
		let pushStateParams = new URLSearchParams();

		if (activeFilters.length > 0) pushStateParams.set('activeFilters', activeFilters.join(','));
		if (activeSearchTerm !== '') pushStateParams.set('resource_searchquery', activeSearchTerm);

		let pushStateUrl = pushStateParams.toString() === '' ? '' : '?' + pushStateParams.toString();

		history.pushState({
			activeFilters: activeFilters,
			activeSearchTerm: activeSearchTerm
		}, document.title, pushStateUrl);

		/**
		 * Show items that only belong to the selected region, and contain any of the selected topics
		 */
		let $visible = $results.filter((idx, el) => {
			let taxes = el.dataset.taxes.split(',');
			let regions = taxes.filter((t) => t.includes('region'));
			let topics = taxes.filter((t) => !t.includes('region'));

			let regionDifference = activeFilters.filter((x) => {
				return x.includes('region') && regions.includes(x);
			});

			// If the only filter selected is all regions, show everything.
			if (activeFilters.length === 1 && activeRegions[0] === 'region-all') return true;

			// If the item doesn't belong to the selected region, hide it, no matter what.
			if (regionDifference.length === 0) return false;

			console.log(regionDifference);

			// Otherwise, show items that have any of the filters selected
			let difference = activeFilters.filter((x) => {
				return activeTopics.length === 0 ? taxes.includes(x) : topics.includes(x);
			});

			return difference.length > 0;
		});

		// Check for search term presence in the excerpt or post_name
		if (activeSearchTerm !== '') {
			$visible = $visible.filter((idx, el) => {
				return (
					el.dataset.slug.indexOf(activeSearchTerm.toLowerCase()) > -1 ||
					el.querySelector('.result__excerpt').innerText.toLowerCase().indexOf(activeSearchTerm.toLowerCase()) > -1
				);
			});
		}

		$visible.show();

		$('#js-sorted-items').children(':visible').length === 0 ? $noResults.show() : $noResults.hide();
	}

	function clear_filters(ev) {
		ev.preventDefault();

		$('.amigo').removeClass('active');

		$filters.each((idx, el) => {
			el.checked = false;
		});

		update_mobile_filters();

		$results.show();

		var href = window.location.href;
		var url = href.split('?');
		history.pushState(null, document.title, url[0]);

		document.getElementById('region-all').checked = true;
	}

	return {
		init: init,
	};
})();
